import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, Checkbox, ConfigProvider, Select, notification, Card, Result } from 'antd';
import { Link, useSearchParams } from 'react-router-dom';
import { CloseCircleOutlined, CheckCircleFilled } from '@ant-design/icons';
import changeHeight from '../data/changeHeight';
//Imports ajenos a el diseño
import axios from 'axios';
import aseguradoras from '../data/aseguradora';

const FormBlogCancelaSeguro = () => {

    const [buttonLoading, setbuttonLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [primaryColor, setPrimaryColor] = useState('#FFFFFF');
    const [searchParams] = useSearchParams();
    const [form] = Form.useForm();
    const refForm = useRef(0);
    const refResult = useRef(0);
    const [result, setResult] = useState("collapse");
    const [urlResponse, seturlResponse] = useState("");
    const [heightResult, setHeightResult] = useState(0);
    const [api, contextHolder] = notification.useNotification();
    const [showBirthday, setShowBirthday] = useState(false);
    const [priceBasic, setPriceBasic] = useState(null);
    const [pricePremium, setPricePremium] = useState(null);

    useEffect(() => {
        if (searchParams.get("primaryColor")) {
            setPrimaryColor('#' + searchParams.get("primaryColor"));
            setResult("none");
            setHeightResult(refResult.current.clientHeight);
        }
        if (searchParams.get("parentUrl")) {
            form.setFieldsValue({ url: decodeURIComponent(searchParams.get("parentUrl")) });
        }
    }, [searchParams]);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
          for (let entry of entries) {
            if (entry.target === refForm.current) {
              changeHeight(entry.target.clientHeight);
              break;
            }
          }
        });
    
        resizeObserver.observe(refForm.current);
    
        return () => {
          resizeObserver.unobserve(refForm.current);
        };
      }, []);

    const onRamoChange = (value) => {
        setShowBirthday(value === 'Vida');
        if (value !== 'Vida') {
            form.setFieldValue('birthday', undefined);
        }
    };

    const validateAge = (_, value) => {
        if (!value) return Promise.reject('Por favor, introduce tu fecha de nacimiento');
        
        const birthDate = new Date(value);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        if (age < 18) {
            return Promise.reject('Debes ser mayor de edad');
        }
        
        return Promise.resolve();
    };

    const onFinish = async (values) => {
        setbuttonLoading(true);
        values.interested_price = false;
        values.interested_price2 = false;
        try {
            // Primera petición (existente)
            const response = await axios.post(`${process.env.REACT_APP_URL_BLOG_CANCELAR}`, values);
            seturlResponse(response.data.carta_url);

            // Si es Vida, hacer la segunda petición
            if (values.ramo === 'Vida') {
                const vidaResponse = await axios.post('https://hook.eu1.make.com/ia28fg17te3oxl276l3sxf0t1crcic1m', {
                    email: values.email,
                    birthday: values.birthday,
                    capital_to_ensure: 50000,
                    from: 'blog_cancelar_seguro'
                });
                
                setPriceBasic(vidaResponse.data.priceBasic);
                setPricePremium(vidaResponse.data.pricePremium);
            }

            setbuttonLoading(false);
            setSuccess(true);
            setResult("block");
            changeHeight(heightResult);
        } catch (error) {
            openNotification('bottom');
            setbuttonLoading(false);
        }
    };

    const openNotification = (placement) => {
        api.info({
            message: 'Error inesperado',
            description:
                'Ha ocurrido un error inesparado. Intentelo más tarde. Disculpe las molestias',
            placement,
            icon: (
                <CloseCircleOutlined style={{ color: "#f7151c" }} />
            )
        });
    };

    return (
        <>
            {contextHolder}
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: primaryColor,
                    },
                }}
            >
                <style>
                    {`
                    ::-webkit-scrollbar {
                        display: none;
                    }
                    `}
                </style>
                <div ref={refForm}>
                    <Card
                        title="Formulario para recibir tu carta de anulación"
                        style={{ width: '100%', backgroundColor: "#f0f2f5" }}
                        headStyle={
                            {
                                backgroundColor: primaryColor,
                                color: "white"
                            }
                        }
                    >
                        <div>
                            <Form
                                form={form}
                                style={{ padding: '1.5rem' }}
                                hidden={success}
                                name="basic"
                                initialValues={{ remember: true }}
                                layout='vertical'
                                onFinish={onFinish}
                            >
                                <Form.Item
                                    hidden={true}
                                    label="URL"
                                    name="url"
                                >
                                    <Input type='text' />
                                </Form.Item>

                                <Form.Item
                                    label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>Nombre y apellidos del asegurado</p>}
                                    name="name"
                                    style={{ marginBottom: "0.6rem" }}
                                    rules={[{ required: true, message: 'Por favor, ingresa tu nombre completo' }]}
                                >
                                    <Input placeholder='Nombre y apellidos' type='text' disabled={buttonLoading} />
                                </Form.Item>

                                <Form.Item
                                    label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>Número de DNI del asegurado</p>}
                                    name="dni"
                                    style={{ marginBottom: "0.6rem" }}
                                    rules={[{ required: true, message: 'Por favor, introduce el DNI asegurado' }]}
                                >
                                    <Input placeholder='12345678A' type='text' disabled={buttonLoading} />
                                </Form.Item>

                                <Form.Item
                                    label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>Nombre de la aseguradora</p>}
                                    name="aseguradora"
                                    style={{ marginBottom: "0.6rem" }}
                                    rules={[{ required: true, message: 'Por favor, escoge tu banco o aseguradora' }]}
                                >
                                    <Select showSearch placeholder='Escoge tu banco o aseguradora' disabled={buttonLoading}>
                                        {aseguradoras.map((aseguradora) => (
                                            <Select.Option key={aseguradora} value={aseguradora}>{aseguradora}</Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>Ramo</p>}
                                    name="ramo"
                                    style={{ marginBottom: "0.6rem" }}
                                    rules={[{ required: true, message: 'Por favor, escoge el ramo de tu seguro' }]}
                                >
                                    <Select 
                                        showSearch 
                                        placeholder='Escoge tu banco o aseguradora' 
                                        disabled={buttonLoading}
                                        onChange={onRamoChange}
                                    >
                                        <Select.Option key='Auto' value='Auto'>Coche/Moto</Select.Option>
                                        <Select.Option key='Hogar' value='Hogar'>Hogar</Select.Option>
                                        <Select.Option key='Salud' value='Salud'>Salud</Select.Option>
                                        <Select.Option key='Vida' value='Vida'>Vida</Select.Option>
                                        <Select.Option key='Accidentes' value='Accidentes'>Accidentes</Select.Option>
                                        <Select.Option key='Otros' value='Otros'>Otros</Select.Option>
                                    </Select>
                                </Form.Item>

                                {showBirthday && (
                                    <Form.Item
                                        label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>Fecha de nacimiento</p>}
                                        name="birthday"
                                        style={{ marginBottom: "0.6rem" }}
                                        rules={[
                                            { required: true, message: '' },
                                            { validator: validateAge }
                                        ]}
                                    >
                                        <Input type="date" disabled={buttonLoading} />
                                    </Form.Item>
                                )}

                                <Form.Item
                                    label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>Referencia / Número de póliza</p>}
                                    name="poliza"
                                    style={{ marginBottom: "0.6rem" }}
                                    rules={[{ required: true, message: 'Por favor, introduzca su referencia o número de póliza' }]}
                                >
                                    <Input type='text' disabled={buttonLoading} />
                                </Form.Item>

                                <Form.Item
                                    label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>Teléfono</p>}
                                    name="telefono"
                                    style={{ marginBottom: "0.6rem" }}
                                    rules={[{ required: true, message: 'Por favor, introduzca su teléfono' }]}
                                >
                                    <Input type='tel' maxLength={9} disabled={buttonLoading} />
                                </Form.Item>

                                <Form.Item
                                    label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>Email</p>}
                                    name="email"
                                    style={{ marginBottom: "0.6rem" }}
                                    rules={[{ required: true, message: 'Por favor, introduzca su correo electrónico' }]}
                                >
                                    <Input type='text' disabled={buttonLoading} />
                                </Form.Item>


                                <Form.Item style={{ marginBottom: '12px' }} valuePropName="checked" name="terms" initialValue={false} rules={[{ required: true, validator: async (_, checked) => { if (!checked) { return Promise.reject(new Error("Por favor, acepta los términos y condiciones")); } } }]}>
                                    <Checkbox disabled={buttonLoading} >Acepto los <Link target='_blank' to='https://www.coventia.es/politica-de-privacidad-y-aviso-de-cookies'>términos y condiciones</Link></Checkbox>
                                </Form.Item>

                                <Form.Item>
                                    <Button type='primary' loading={buttonLoading} htmlType="submit">
                                        {buttonLoading ? 'Enviando...' : 'Recibir la carta para cancelar mi seguro'}
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                        <div ref={refResult}>
                            <div style={{ display: `${result}`, padding: '1.5rem' }}>
                                <Result
                                    icon={form.getFieldValue('ramo') === 'Hogar' || form.getFieldValue('ramo') === 'Salud' ? null : <CheckCircleFilled style={{ color: primaryColor }} />}
                                    style={{ display: `${result}`, padding: '1.5rem', paddingTop: '3rem' }}
                                    status={form.getFieldValue('ramo') === 'Hogar' || form.getFieldValue('ramo') === 'Salud' ? '' : 'success'}
                                    title={form.getFieldValue('ramo') === 'Hogar' || form.getFieldValue('ramo') === 'Salud' ? '' : '¡Hecho! Revisa tu email'}
                                    subTitle={
                                        <>
                                            {form.getFieldValue('ramo') === 'Hogar' || form.getFieldValue('ramo') === 'Salud' ? (
                                                null
                                            ) : (
                                                <p>{`Muchas gracias ${form.getFieldValue('name')}! Hemos enviado a tu email la carta para que solicites la cancelación de tu seguro.`}</p>
                                            )}
                                            {priceBasic && pricePremium && (
                                                <div style={{
                                                    marginTop: '30px',
                                                    padding: '20px',
                                                    border: `2px solid ${primaryColor}`,
                                                    borderRadius: '8px',
                                                    backgroundColor: '#f8f9fa'
                                                }}>
                                                    <h3 style={{
                                                        color: primaryColor,
                                                        textAlign: 'center',
                                                        marginBottom: '20px',
                                                        fontSize: '1.5em'
                                                    }}>
                                                        ¡Espera! Tenemos esta oferta para que sigas cubierto por tan solo...
                                                    </h3>
                                                    
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        gap: '20px',
                                                        flexWrap: 'wrap'
                                                    }}>
                                                        {/* Plan Básico */}
                                                        <Card style={{
                                                            width: 300,
                                                            textAlign: 'center',
                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                                        }}>
                                                            <h4>Seguro de fallecimiento</h4>
                                                            <div style={{
                                                                fontSize: '2em',
                                                                color: primaryColor,
                                                                margin: '15px 0'
                                                            }}>
                                                                {priceBasic}€
                                                                <span style={{
                                                                    fontSize: '0.4em',
                                                                    color: '#666'
                                                                }}>/año</span>
                                                            </div>
                                                            <ul style={{
                                                                listStyle: 'none',
                                                                padding: 0,
                                                                margin: '20px 0',
                                                                textAlign: 'left'
                                                            }}>
                                                                <li>✓ Cobertura por fallecimiento</li>
                                                                <li>✓ Capital asegurado: 50.000€</li>
                                                                <li>✓ Sin período de carencia</li>
                                                            </ul>
                                                            <Button 
                                                                type="primary"
                                                                href={`https://wa.me/34960130494?text=Hola,%20me%20interesa%20el%20seguro%20Fall%20por%20${priceBasic}€%20al%20año`}
                                                                target="_blank"
                                                                style={{width: '100%'}}
                                                            >
                                                                Contactar por WhatsApp
                                                            </Button>
                                                            <Button 
                                                                type="primary"
                                                                href={`https://meetings-eu1.hubspot.com/santiago-gatti`}
                                                                target="_blank"
                                                                style={{width: '100%', marginTop: '10px'}}
                                                            >
                                                                Concertar cita
                                                            </Button>
                                                        </Card>

                                                        {/* Plan Premium */}
                                                        <Card style={{
                                                            width: 300,
                                                            textAlign: 'center',
                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                            border: `2px solid ${primaryColor}`
                                                        }}>
                                                            <h4>Seguro Fall + Invalidez</h4>
                                                            <div style={{
                                                                fontSize: '2em',
                                                                color: primaryColor,
                                                                margin: '15px 0'
                                                            }}>
                                                                {pricePremium}€
                                                                <span style={{
                                                                    fontSize: '0.4em',
                                                                    color: '#666'
                                                                }}>/año</span>
                                                            </div>
                                                            <ul style={{
                                                                listStyle: 'none',
                                                                padding: 0,
                                                                margin: '20px 0',
                                                                textAlign: 'left'
                                                            }}>
                                                                <li>✓ Cobertura por fallecimiento</li>
                                                                <li>✓ Invalidez permanente absoluta</li>
                                                                <li>✓ Capital asegurado: 50.000€</li>
                                                                <li>✓ Sin período de carencia</li>
                                                            </ul>
                                                            <Button 
                                                                type="primary"
                                                                href={`https://wa.me/34960130494?text=Hola,%20me%20interesa%20el%20seguro%20Fall%2BIPA%20por%20${pricePremium}€%20al%20año`}
                                                                target="_blank"
                                                                style={{width: '100%'}}
                                                            >
                                                                Contactar por WhatsApp
                                                            </Button>
                                                            <Button 
                                                                type="primary"
                                                                href={`https://meetings-eu1.hubspot.com/santiago-gatti`}
                                                                target="_blank"
                                                                style={{width: '100%', marginTop: '10px'}}
                                                            >
                                                                Concertar cita
                                                            </Button>
                                                        </Card>
                                                    </div>
                                                    
                                                    <div style={{
                                                        textAlign: 'center',
                                                        marginTop: '20px',
                                                        color: '#666'
                                                    }}>
                                                        <p>¿Prefieres que te llamemos? Llámanos al <a href="tel:919993131">919 993 131</a></p>
                                                    </div>
                                                </div>
                                            )}
                                            {(form.getFieldValue('ramo') === 'Hogar' || form.getFieldValue('ramo') === 'Salud') && (
                                                <div style={{
                                                    padding: '40px 24px 48px 24px', // padding-bottom aumentado
                                                    border: '2.5px solid #0B0B4E',
                                                    borderRadius: '18px',
                                                    background: '#f6f7fb',
                                                    textAlign: 'center',
                                                    boxShadow: '0 6px 32px rgba(11, 11, 78, 0.10)',
                                                    maxWidth: 600,
                                                    marginLeft: 'auto',
                                                    marginRight: 'auto',
                                                    position: 'relative'
                                                }}>
                                                    <div style={{
                                                        position: 'absolute',
                                                        top: '-32px',
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        background: '#fff',
                                                        borderRadius: '50%',
                                                        width: 64,
                                                        height: 64,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        boxShadow: '0 2px 8px rgba(11, 11, 78, 0.10)'
                                                    }}>
                                                        <svg width="36" height="36" fill="#0B0B4E" viewBox="0 0 24 24"><path d="M12 2C6.477 2 2 6.477 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10C22 6.477 17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8 0-4.418 3.582-8 8-8 4.418 0 8 3.582 8 8 0 4.418-3.582 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/></svg>
                                                    </div>
                                                    <h2 style={{ color: '#0B0B4E', fontWeight: 800, fontSize: '2.1em', marginTop: 32 }}>
                                                        ¿Quieres que nos encarguemos de cancelar tu seguro de {form.getFieldValue('ramo')}?
                                                    </h2>
                                                    <p style={{ fontSize: '1.15em', margin: '18px 0 28px 0', color: '#222' }}>
                                                        Por solo <span style={{ color: '#0B0B4E', fontWeight: 700 }}>29,99 €</span> nos ocupamos de todo el proceso de cancelación por ti.
                                                    </p>
                                                    <ul style={{
                                                        textAlign: 'left',
                                                        display: 'inline-block',
                                                        margin: '0 auto 32px auto',
                                                        fontSize: '1.13em',
                                                        color: '#222',
                                                        padding: 0,
                                                        listStyle: 'none',
                                                        fontWeight: 500
                                                    }}>
                                                        <li style={{marginBottom: 10}}><span style={{color:'#0B0B4E', fontSize:'1.2em', marginRight:8, verticalAlign:'middle'}}>✔️</span> Olvídate de papeleos y llamadas</li>
                                                        <li style={{marginBottom: 10}}><span style={{color:'#0B0B4E', fontSize:'1.2em', marginRight:8, verticalAlign:'middle'}}>🔒</span> Gestión 100% profesional y segura</li>
                                                        <li style={{marginBottom: 10}}><span style={{color:'#0B0B4E', fontSize:'1.2em', marginRight:8, verticalAlign:'middle'}}>⏱️</span> Ahorra tiempo y evita complicaciones</li>
                                                        <li><span style={{color:'#0B0B4E', fontSize:'1.2em', marginRight:8, verticalAlign:'middle'}}>🤝</span> Seguimiento personalizado de tu caso</li>
                                                    </ul>
                                                    <Button
                                                        type="primary"
                                                        size="large"
                                                        style={{
                                                            background: '#0B0B4E',
                                                            borderColor: '#0B0B4E',
                                                            color: '#fff',
                                                            fontWeight: 700,
                                                            fontSize: '1.25em',
                                                            width: '100%',
                                                            maxWidth: 340,
                                                            margin: '0 auto',
                                                            display: 'block',
                                                            borderRadius: '8px',
                                                            boxShadow: '0 2px 8px rgba(11, 11, 78, 0.10)',
                                                            marginBottom: 16
                                                        }}
                                                        href={`https://buy.stripe.com/14AbIUf6lbuicsv1kC6Vq02?prefilled_email=${encodeURIComponent(form.getFieldValue('email'))}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Cancelar mi seguro por 29,99 €
                                                    </Button>
                                                    <p style={{ marginTop: '22px', color: '#0B0B4E', fontWeight: 600, fontSize: '1.05em' }}>
                                                        ¡Deja que Coventia se encargue de todo por ti!
                                                    </p>
                                                </div>
                                            )}
                                        </>
                                    }
                                />
                            </div>
                        </div>
                    </Card>
                </div>
            </ConfigProvider>
        </>
    );
}

export default FormBlogCancelaSeguro;
